/**
 * Formate un montant en dinars tunisiens : 2 décimales, virgule décimale et
 * espace fine comme séparateur de milliers — ex. 287.5 → « 287,50 DT »,
 * 1234.5 → « 1 234,50 DT » (cf. SCRUM-79).
 */
export function formatDt(value: number): string {
  const [intPart, decPart] = value.toFixed(2).split('.')
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return `${grouped},${decPart} DT`
}

/** Note moyenne sur 5, ou « — » si aucune note disponible (dépendance SCRUM-74/76). */
export function formatRating(rating: number | null): string {
  if (rating === null) return '—'
  return rating.toFixed(1).replace('.', ',')
}

/** Tendance signée à une décimale, ex. 12.5 → « +12,5 % », -4 → « −4 % ». */
export function formatTrend(pct: number): string {
  const sign = pct > 0 ? '+' : pct < 0 ? '−' : ''
  const abs = Math.abs(pct)
  const text = (Number.isInteger(abs) ? String(abs) : abs.toFixed(1)).replace('.', ',')
  return `${sign}${text} %`
}
